export const bidAwardeeLabels = {
  awardees: 'Awardees',
  bidAwardees: 'Awardee Management',
  requiredDocumentListDescription:
    'This list shows the status of documents specific to the selected awardee.',
} as const;
export const maxBidIdentifierLength = 100;
